import { SimilaritySearchAssetDto } from "generated";
import Text from "@ingka/text";
import Image from "@ingka/image";
import Button from "@ingka/button";
import SimilarImageCard from "./SimilarImageCard";

type Props = {
  fileToUploadUrl: string;
  filename: string;
  similarFiles: SimilaritySearchAssetDto[];
};

export function ModalBodyWithSimilarImages({
  fileToUploadUrl,
  filename,
  similarFiles,
}: Props) {
  return (
    <div className="flex flex-col px-space125">
      <Text tagName="h2" headingSize="xs" className="my-space100">
        File you selected to upload
      </Text>
      <div className="mb-space50 h-[10rem] w-[10rem]">
        <Image
          className="h-full w-full object-cover"
          src={fileToUploadUrl}
          alt={filename}
        />
        <Text tagName="span" bodySize="s">
          {filename}
        </Text>
      </div>
      <div className="mb-space100 mt-space250">
        <Text tagName="h3" headingSize="xs">
          Similar assets already in DAM
        </Text>
        <ul className="grid grid-cols-2 gap-space100">
          {similarFiles.map((file) => (
            <SimilarImageCard key={file.id} file={file} />
          ))}
        </ul>
      </div>
      <div className="m-space300">
        <Button
          target="_blank"
          href="https://confluence.build.ingka.ikea.com/display/ODCH/Instruction+videos%3A+Ingka+DAM"
          className="w-full"
          type="secondary"
          text="How to view more similar images"
        />
      </div>
    </div>
  );
}
